export default __webpack_public_path__ + "static/media/Logo.b3cddd2d.svg";